<!-- ThankYou.vue -->
<template>
  <div class="container">
    <div class="row">
      <div class="contact-image col-lg-4 col-sm-12 col-md-12">
        <div class="d-flex justify-content-center align-items-center flex-column gap-3">
          <img src="/images/online-help.svg" class="how-customer-img" alt="Customer Care" width="320" height="320" />
          <div class="contact-options">
            <div class="contactInfo" data-v-4f9fa935="">
              <strong data-v-4f9fa935="">WhatsApp </strong> 
              <a href="https://wa.me/447539357629" data-v-4f9fa935="">07539 357629</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 mt-4 mb-4 contact-us">
        <h1 class="mb-4">Contact Us</h1>
        <form @submit.prevent="submit">
          <div class="form-floating mb-3">
            <input
              id="name"
              name="name"
              type="text"
              class="form-control"
              placeholder="Full Name"
              v-model="form.name"
            />
            <label class="text-dark" for="name">Full Name</label>
            <h6 v-if="nameError === true" class="text-red">
              Oooooops, you forgot to add your name!
            </h6>
          </div>
          <div class="form-floating mb-3">
            <input
              id="email"
              name="email"
              type="email"
              class="form-control"
              placeholder="email@email.com"
              v-model="form.email"
            />
            <label class="text-dark" for="email">Email</label>
            <h6 v-if="emailError === true" class="text-red">
              Oooooops, you forgot to provide us with an email address!
            </h6>
          </div>
          <div class="form-floating mb-3">
            <textarea
              id="message"
              name="message"
              class="form-control"
              placeholder="Leave a comment here"
              style="height: 100px"
              v-model="form.body"
            ></textarea>
            <label class="text-dark" for="message">Message</label>
            <h6 v-if="bodyError === true" class="text-red">
              Oooooops, you forgot to add a message!
            </h6>
          </div>
          <button 
            v-if="!success" 
            type="submit" 
            class="button button-outline-light mb-3" 
            :disabled="loading"
          >
            <span v-if="!loading">Submit</span>
            <span v-else>Sending...</span>
          </button>
          <h6 v-if="success === true" class="text-aqua">
            Thank you, your enquiry has been submitted successfully! We will be
            in touch ASAP
          </h6>
          <h6 v-if="error === true" class="text-red">
            Ooops! There's been an error, please refresh the page and try again
          </h6>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        body: "",
      },
      nameError: false,
      emailError: false,
      bodyError: false,
      success: false,
      error: false,
      loading: false,
    };
  },
  methods: {
    submit() {
      this.success = false;
      this.error = false;
      this.nameError = false;
      this.emailError = false;
      this.bodyError = false;
      
      if (this.form.name === "") {
        this.nameError = true;
        return;
      }
      if (this.form.email === "") {
        this.emailError = true;
        return;
      }
      if (this.form.body === "") {
        this.bodyError = true;
        return;
      } else {
        this.loading = true;
        try {
          const params = {
            name: this.form.name,
            // User details
            email: this.form.email,
            body: this.form.body,
          };
          const url = process.env.VUE_APP_SUPASMART + "contact_send_mail";

          axios
            .post(url, params)
            .then((response) => {
              // Handle successful response here
              console.log("Response:", response.data);
              if (response && response.data.success == true) {
                this.success = true;
              } else {
                this.error = true;
              }
            })
            .catch((error) => {
              // Handle error
              this.error = true;
              console.error("Error:", error);
            })
            .finally(() => {
              this.loading = false;
            });
        } catch (error) {
          console.log(error);
          this.error = true;
          this.loading = false;
        }
        // Here you can send the form data to your server
      }
    },
  },
};
</script>


<style scoped lang="scss">
  .container {

    .row {
      justify-content: center;
      gap: 2rem;
      padding: 2rem;
    }
      
    .contact-image {
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        width: 100%;
      }
    }

    .contact-us h1 {
      color: var(--banana);
    }

    .contact-options {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .contactInfo {
        display: flex;
        gap: 1rem;
        align-items: center;
        font-weight: 600;
      }

      strong {
        background: var(--peach);
        color: var(--black);
        padding: .3rem 1rem;
        border-radius: 100px;
        
      }
    }
  }

  @media (max-width: 768px) {
    .container .row {
      padding: 1rem;
      gap: 1rem;
    }
    
    .form-floating {
      position: relative;
      
      input, textarea {
        padding: 1rem 0.75rem 0.5rem 0.75rem !important;
        font-size: 1rem;
        line-height: 1.25;
      }
      
      label {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0.375rem 0.75rem;
        margin: 0;
        font-size: 1rem;
        color: #6c757d !important;
        pointer-events: none;
        border: 1px solid transparent;
        transform-origin: 0 0;
        transition: opacity 0.2s ease-in-out;
      }
      
      input:focus ~ label,
      input:not(:placeholder-shown) ~ label,
      textarea:focus ~ label,
      textarea:not(:placeholder-shown) ~ label {
        opacity: 0;
      }
    }
    
    .contact-us h1 {
      font-size: 1.75rem;
      margin-bottom: 1.5rem;
    }
  }

  @media (max-width: 480px) {
    .container .row {
      padding: 0.5rem;
    }
    
    .form-floating {
      input, textarea {
        padding: 1rem 0.75rem 0.5rem 0.75rem !important;
         font-size: 1.5rem;
      }
      
      label {
        padding: 0.25rem 0.75rem;
        font-size: 1.5rem;
      }
    }
    
    .contact-us h1 {
      font-size: 1.5rem;
      text-align: center;
    }
  }
</style>

<style>
.form-group {
  margin-bottom: 1rem;
}
input[type="text"],
input[type="email"],
textarea {
  width: 100%;
  padding: 0.5rem;
}
button {
  padding: 0.5rem 1rem;
  background-color: black;
  border-radius: 10px;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.text-red {
  color: red;
  font-weight: 300;
}
.text-green {
  color: green;
  font-weight: 400;
}
.text-aqua {
  color: aqua;
  font-weight: 400;
}
</style>

